<template>
  <div class="modal-content">
    <div class="modal-header">
      <h3 class="modal-title">{{ _('Notifications and Offers from Sales Channels') }}</h3>
    </div>
    <div class="modal-body">
      <template v-if="requests.length">
        <div class="row">
    			<div class="col-md-12">
  	  			<h4>{{ _('Requests to Access Your Sales Channel') }}</h4>
    				<div class="panel-group flex-panel" id="saleschannelrequests">
              <div class="panel panel-default" v-for="(req, index) in requests">
                <div class="panel-heading bg-info" :id="'headingRequest' + index">
                  <h5 class="panel-title">
                    <a role="button" data-toggle="collapse" :aria-expanded="(!parseInt(index) ? 'true' : 'false')" data-parent="#saleschannelrequests" :href="'#requestsCollapse' + index">
                      <span class="title-text">{{ req.requestingshop.companyname }} ({{ req.requestingshop.shopid }})</span>
                      <span class="indicator"></span>
                    </a>
                  </h5>
                </div>
                <div :id="'requestsCollapse' + index" :class="'panel-collapse collapse' + (!parseInt(index) ? ' in' : '')">
                  <div class="panel-body">
                    <p v-if="req.message"><i>{{ req.message }}</i></p>
                    <div class="form-group" v-if="req.requestingshop.companyemail">
                      <label>{{ _('Email') }}</label>
                      <p>{{ req.requestingshop.companyemail }}</p>
                    </div>
                    <div class="form-group" v-if="req.requestingshop.companyphone">
                      <label>{{ _('Phone') }}</label>
                      <p>{{ req.requestingshop.companyphone }}</p>
                    </div>
                    <div class="form-group">
                      <label for="ignore_commission">{{ _('Commission') }}</label>
                      <div class="input-group">
                        <input type="number" data-android-inputmode="decimal" class="form-control" :value="req.defaultcommission" v-on:change="commissionChanged(req, $event.target.value)">
                        <div class="input-group-addon">%</div>
                      </div>
                    </div>
                    <div class="button-col">
                      <button type="button" class="btn btn-success" v-on:click="approveRequest(req)"><i class="fa fa-fw fa-check"></i> {{ _('Approve') }}</button>
                      <button type="button" class="btn btn-danger" v-on:click="rejectRequest(req)"><i class="fa fa-fw fa-ban"></i> {{ _('Reject') }}</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-if="offers.length">
        <div class="row">
    			<div class="col-md-12">
  	  			<h4>{{ _('Offers from Sales Channels') }}</h4>
    				<div class="panel-group flex-panel" id="saleschanneloffers">
              <div class="panel panel-default" v-for="(offer, index) in offers">
                <div class="panel-heading bg-info" :id="'headingOffer' + index">
                  <h5 class="panel-title">
                    <a role="button" data-toggle="collapse" data-parent="#saleschanneloffers" :href="'#offersCollapse' + index">
                      <span class="title-text">{{ offer.title }} ({{ offer.channel }})</span>
                      <span class="indicator"></span>
                    </a>
                  </h5>
                </div>
                <div :id="'offersCollapse' + index" :class="'panel-collapse collapse' + (!parseInt(index) ? ' in' : '')">
                  <div class="panel-body">
                    <p v-if="offer.offer && offer.offer.message"><i>{{ offer.offer.message }}</i></p>
                    <div class="form-group" v-if="offer.email">
                      <label>{{ _('Email') }}</label>
                      <p>{{ offer.email }}</p>
                    </div>
                    <div class="form-group" v-if="offer.phone">
                      <label>{{ _('Phone') }}</label>
                      <p>{{ offer.phone }}</p>
                    </div>
                    <div class="form-group" v-if="offer.offer">
                      <label for="ignore_commission">{{ _('Commission') }}</label>
                      <div class="input-group">
                        <input type="number" data-android-inputmode="decimal" class="form-control" name="ignore_commission" :value="offer.offer.commission" disabled="disabled">
                        <div class="input-group-addon">%</div>
                      </div>
                    </div>
                    <div class="button-col">
                      <button type="button" class="btn btn-success" v-on:click="acceptOffer(offer)"><i class="fa fa-fw fa-check"></i> {{ _('Enable') }}</button>
                      <button type="button" class="btn btn-danger" v-on:click="rejectOffer(offer)"><i class="fa fa-fw fa-ban"></i> {{ _('Reject') }}</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-primary hidden-xs" v-on:click="close"><i class="fa fa-close fa-fw"></i>{{ _('Close') }}</button>
    </div>      
  </div>
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
import errors from '~/lib/errors'

export default {
  data () {
    return {
      offers: [],
      requests: []
    }
  },
  mixins: [errors],
  props: ['incomingOffers', 'incomingRequests'],
  computed: {
    ...mapGetters(['baseDomain', 'shopId', 'apiKey']),
  },
  methods: {
    close () {
      this.$emit('close')
    },
    approveRequest (req) {
      this.sendRequest(req, 'approve')
    },
    rejectRequest (req) {
      this.sendRequest(req, 'reject')
    },
    async sendRequest (req, action) {
      let response
			const data = {
        action,
        commission: req.defaultcommission,
        shopId: req.requestingshop.shopid
      }
      try {
        response = await axios.put(this.baseDomain + this.shopId + '/johkusaleschannels.json?apikey=' + this.apiKey, data)
      } catch(e) {
        this.showError(e)
        return
      }
      this.requests = this.requests.filter(r => r.requestingshop.id !== req.requestingshop.id)
    },
    acceptOffer (offer) {
      this.sendOffer(offer, 'acceptoffer')
    },
    rejectOffer (offer) {
      this.sendOffer(offer, 'rejectoffer')
    },
    async sendOffer (offer, action) {
      let response
			const data = {
        action,
        channelId: offer.id
      }
      try {
        response = await axios.put(this.baseDomain + this.shopId + '/johkusaleschannels.json?apikey=' + this.apiKey, data)
      } catch(e) {
        this.showError(e)
        return
      }
      this.offers = this.offers.filter(o => o.id != offer.id)
    },
    commissionChanged (req, newValue) {
      req.defaultcommission = newValue
    }
  },
  created() {
    this.offers = [...this.incomingOffers]
    this.requests = [...this.incomingRequests]
  }
}  

</script>